const state = {
  nav: {},
  rule: {}
};

const getters = {
  getNav: state => {
    return state;
  }
};

const actions = {
  setNav({ commit }, obj) {
    commit("setNav", obj);
  }
};

const mutations = {
  setNav(state, obj) {
    if (process.env.NODE_ENV != "development") {
      let _menu = obj.menu.filter(m => {
        return true;
      });

      obj.menu = _menu;
      state.nav = obj;
    } else {
      state.nav = obj;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
